import { InfoProyectoCellRenderer } from "../../../../../shared/components/CustomCells/InfoProyectoCellrenderer";
import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

// const getSociedad = (params)=>{
//   return params.data.sociedades.length>0 ? params.data.sociedades[0].sociedad : null
// }

export const getColumnDefs = () => {
  return [
    ColumnsFactory.BooleanColumn("Visible", "visible"),
    ColumnsFactory.TextColumn("DN/SG", "idDN"),
    ColumnsFactory.TextColumn("Código", "codigoProyecto"),
    ColumnsFactory.TextColumn("Proyecto", "proyecto"),
    ColumnsFactory.DateColumn("Fecha Baja", "fechaBaja"),
    ColumnsFactory.BooleanColumn("Ingeniería", "esIngenieria"),
    ColumnsFactory.TextColumn("Sociedades", 'sociedadesListado'),
    ColumnsFactory.PopoverColumn("Información","idProyecto", {cellRendererFramework:InfoProyectoCellRenderer})
  ];
};
